import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssetsCategory } from '../../models/types/assets-category.enum';
import { ToastIcons, ToastPosition, ToastType } from '../../models/types/toast.enum';
import { IconComponent } from '../icons/icons.component';

@Component({
  selector: 'lib-toast',
  imports: [CommonModule, IconComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  @Input() message = '';
  @Input() type: ToastType = ToastType.Success;
  @Input() position: ToastPosition = ToastPosition.BottomRight;

  ToastIcons = ToastIcons;
  AssetsCategory = AssetsCategory;

  show = true;
  closeToast(): void {
    this.show = false;
  }

  get toastConfig() {
    const configMap: Record<
      string,
      { class: string; title: string; icon: string; position: string }
    > = {
      success: {
        class: 'border-success',
        title: 'Success',
        icon: ToastIcons.Success,
        position:
          this.position == ToastPosition.BottomRight || this.position == ToastPosition.TopRight
            ? 'animate-slide-in-out-right'
            : 'animate-slide-in-out-left',
      },
      error: {
        class: 'border-error',
        title: 'Error',
        icon: ToastIcons.Error,
        position:
          this.position == ToastPosition.BottomRight || this.position == ToastPosition.TopRight
            ? 'animate-slide-in-out-right'
            : 'animate-slide-in-out-left',
      },
    };

    return configMap[this.type] ?? { class: '', title: '', icon: '', position: '' };
  }
}
